const canvas = {
  showGrid: "הצג רשת",
  snapToGrid: "הצמד לרשת",
  zoom: "זום",
  addField: "הוסף שדה",
  placedBy: 'הונח ע"י',
  placedAt: "הונח בתאריך",
  lastMoved: "הוזז לאחרונה",
  usedInDocuments: "בשימוש במסמכים",
  fieldGraph: "גרף שדות",
  editorZone: "אזור עריכה",
  resetLayout: "אפס פריסה",
  documents: "מסמכים",
  fields: "שדות",
  documentTitle: "כותרת המסמך",
  saving: "שומר...",
  saved: "✓ נשמר",
  retrying: "מנסה שוב...",
  saveError: "⚠ שגיאה בשמירה",
  conflict: "⚠ המסמך עודכן בטאב אחר",
  offline: "☁ אופליין — נשמר מקומית",
  editorWidth: "רוחב עורך",
  widthNarrow: "צר",
  widthMedium: "בינוני",
  widthWide: "רחב",
  widthFull: "מלא",
} as const;
export default canvas;
